import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { GroupOperations } from 'components/GroupOperations';
import { ScrollTopButton } from 'components/ScrollTopButton';
import { AsideMedia } from 'layout/AsideMedia';
import { Media } from 'layout/Media';
import { MobileScreens } from 'layout/MobileScreens';
import { PopupsContainer } from 'layout/PopupsContainer';
import { Search } from 'layout/Search';
import { PopularDestinations } from 'layout/Search/PopularDestinations';
import css from 'styles/main.module.css';

const Home = () => {
  return (
    <div className={css.layout}>
      <main className={css.main}>
        <div className={css.search}>
          <Search />
        </div>

        <div className={css.media}>
          <Media />
          <PopularDestinations />
        </div>

        <div className={cn(css.panel, 'glz-z-above-datepicker')}>
          <GroupOperations />
          <ScrollTopButton />
        </div>
      </main>

      <aside className={css.asideMedia}>
        <AsideMedia />
      </aside>

      <PopupsContainer />
      <MobileScreens />
    </div>
  );
};

const connected = observer(Home);

export { connected as default };
